import React from "react";

const cdn = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

const blogImages = {
  graphql: cdn("photo-1518779578993-ec3579fee39f"),
  security: cdn("photo-1556740749-887f6717d7e4"),
  restful: cdn("photo-1483478550801-ceba5fe50e8e"),
  formik: cdn("photo-1461749280684-dccba630e2f6"),
  reactForms: cdn("photo-1503676260728-1c00da094a0b"),
};

const blogPosts = [
  {
    title: "GraphQL + Mongoose",
    description:
      "Building a GraphQL server with Mongo models, secure resolvers, and clear schema design.",
    img: blogImages.graphql,
    link: "https://github.com/juac08/graphql",
    read: "20 min",
  },
  {
    title: "User Security",
    description:
      "Auth flows covering login, logout, register, MongoDB, Node.js, and real-world security patterns.",
    img: blogImages.security,
    link: "https://github.com/juac08/Authorization-",
    read: "15 min",
  },
  {
    title: "RESTful API",
    description:
      "Creating RESTful APIs in Node.js with routing, controllers, and predictable responses.",
    img: blogImages.restful,
    link: "https://github.com/juac08/RESTFull-API",
    read: "12 min",
  },
  {
    title: "Forms with Formik",
    description:
      "Reusable form patterns, validation, and submission flows using Formik.",
    img: blogImages.formik,
    link: "https://formswithformik.netlify.app",
  },
  {
    title: "Formik React",
    description:
      "A deeper dive on production-ready React forms with Formik and custom inputs.",
    img: blogImages.reactForms,
    link: "https://github.com/juac08/Formik.git",
  },
];

function Blog() {
  return (
    <>
      <section className="section blog" data-aos="fade-in">
        <div className="section-title">
          <h2>blog</h2>
          <div className="underline"></div>
        </div>

        <div className="section-center blog-center" data-aos="fade-in">
          {blogPosts.map((post) => (
            <a
              className="blog-card link-card"
              data-aos="fade-in"
              key={post.title}
              href={post.link}
            >
              <img className="blog-img" src={post.img} alt={post.title} />
              <div className="blog-info">
                <h4>{post.title}</h4>
                <p>{post.description}</p>
              </div>
            </a>
          ))}
        </div>
      </section>
    </>
  );
}

export default Blog;
